<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        Offer Group Type
      </div>
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="ogt_name"
                type="text"
                name="ogt_name"
                id="ogt_name"
                v-validate="'required'"
              />
              <label>Offer Group Type</label>
            </div>
            <!-- <Tooltip :title="$t('movie_label_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && !ogt_name">{{ "Required." }}</span>
          </p>
        </div>
        <div class="col-lg-6 col-xl-4 align-self-center mb-5">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="ogt_alternate_name"
                type="text"
                name="ogt_alternate_name"
                id="ogt_alternate_name"
                v-validate="'required'"
              />
              <label>Offer Group Type Alternate name</label>
            </div>
            <!-- <Tooltip :title="$t('movie_label_tooltip')" /> -->
          </div>
        </div>
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="ogt_order"
                type="number"
                name="ogt_order"
                id="ogt_order"
                v-validate="'required'"
              />
              <label>Offer Group Type Order Number</label>
            </div>
            <!-- <Tooltip :title="$t('movie_label_tooltip')" /> -->
          </div>
          <p class="error_message">
            <span v-if="submitted && !ogt_order">{{ "Required." }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-5">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-3">Active</label>
            <b-form-checkbox
              unchecked-value="N"
              value="Y"
              v-model="ogt_name_is_active"
              name="check-button"
              switch
              class="j-checkbox"
            ></b-form-checkbox>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button @click.prevent.stop="resetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            @click="cancel"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
export default {
  components: {},
  data() {
    return {
      ogt_id: null,
      ogt_name: "",
      ogt_alternate_name: "",
      ogt_order: "",
      ogt_name_is_active: "Y",
      btenable: false,
      submitted: false
    };
  },
  beforeMount() {},
  mounted() {
    const { ogt_id } = this.$route.params;
    if (ogt_id) {
      this.getOfferGroupType(ogt_id);
    }
  },
  methods: {
    getOfferGroupType(ogt_id) {
      let payload = {
        ogt_id: ogt_id
      };
      MarketingService.GetAllOfferGroupType(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.ogt_name = data.Records[0].ogt_type_name;
              this.ogt_alternate_name = data.Records[0].ogt_alternate_name;
              this.ogt_order = data.Records[0].ogt_order;
              this.ogt_id = data.Records[0].ogt_id;
              this.ogt_name_is_active = data.Records[0].ogt_is_active;
            } else {
              console.log("Error:", data.message);
              this.$toasted.show(data.message);
            }
          } else {
            console.log("Error:", data.message);
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          console.log("Error:", err);
        });
    },
    OnFinalSubmit: function(redirect) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          if (!this.ogt_name) {
            return this.$toasted.show("Please Enter Group Name");
          } else {
            let payload = {
              ogt_type_name: this.ogt_name,
              ogt_order: this.ogt_order,
              ogt_is_active: this.ogt_name_is_active,
              ogt_alternate_name: this.ogt_alternate_name
            };
            if (this.ogt_id) {
              payload["ogt_id"] = this.ogt_id;
              payload["type_name"] = "edit";
              MarketingService.AddEditOfferGroupType(payload)
                .then(response => {
                  this.btenable = false;
                  const { data } = response;
                  if (data && data.status) {
                    this.resetForm();
                    if (redirect) {
                      this.$router.push({
                        path: "/marketing/offer-group-type"
                      });
                    }
                    this.submitted = false;
                    this.$toasted.show(data.message);
                  } else {
                    this.$toasted.show(data.message);
                  }
                })
                .catch(err => {
                  console.log("Error:", err);
                });
            } else {
              MarketingService.AddEditOfferGroupType(payload)
                .then(response => {
                  this.btenable = false;
                  const { data } = response;
                  if (data && data.status) {
                    this.resetForm();
                    if (redirect) {
                      this.$router.push({
                        path: "/marketing/offer-group-type"
                      });
                    }
                    this.submitted = false;
                    this.$toasted.show(data.message);
                  } else {
                    this.$toasted.show(data.message);
                  }
                })
                .catch(err => {
                  console.log("Error:", err);
                });
            }
          }
        }
      });
    },
    resetForm: function() {
      this.ogt_id = null;
      this.ogt_name_name = "";
      this.ogt_alternate_name = "";
      (this.ogt_order = ""), (this.ogt_name_is_active_active = "Y");
      this.submitted = false;
      this.btenable = false;
    },
    cancel() {
      this.$router.push({ path: "/marketing/offer-group-type" });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/OfferGroupType/AddEditOfferGroupType.vue